<template>

  <section class="" style="background: #F6F6F6;color:black">
    <div class="container ">
      <div class="section-title page-title">

        <div class="row m-0">
          <div class="col-12">
            <div class="content text-center">

              <ContentsCapitalLabel
                isSecondaryColor="true"
                label="WE SERVE CUSTOMERS FROM LEADING INDUSTRY"
              />
      
              <h2 class="title h2-caslon text-black text-center f-44 fw-600">Industries</h2>

            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-row bg-grey">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12">

          <div class="row m-0">
            <div class="col-12 col-md-4 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/industries/automotive-and-e-mobility">
                    <img src="/pages/products/industries/auto-1.jpg" alt="">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/industries/automotive-and-e-mobility" class="card-title ff-open-sans f-21 fw-600">Automotive and E-mobility</a>
                  <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>

            <div class="col-12 col-md-4 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/industries/electrical-electronics">
                    <img src="/pages/products/industries/elec.jpg" alt="">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/industries/electrical-electronics" class="card-title ff-open-sans f-21 fw-600">Electrical & Electronics</a>
                  <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>

            <div class="col-12 col-md-4 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/industries/office-automation">
                    <img src="/pages/products/industries/automation.jpg" alt="">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/industries/office-automation" class="card-title ff-open-sans f-21 fw-600">Office automation</a>
                  <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>

  <section class="section-row pt-0 bg-grey">
    <div class="container page-container">
      <div class="row m-0">
        <div class="col-12">

          <div class="row m-0">
            <div class="col-12 col-md-4 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/industries/home-appliances">
                    <img src="/pages/products/industries/home.jpg" alt="">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/industries/home-appliances" class="card-title ff-open-sans f-21 fw-600">Home Appliances</a>
                  <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>

            <div class="col-12 col-md-4 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/industries/medical-devices">
                    <img src="/pages/products/industries/madical.jpg" alt="">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/industries/medical-devices" class="card-title ff-open-sans f-21 fw-600">Medical devices</a>
                  <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>

            <div class="col-12 col-md-4 p-0">
              <!-- CARD IMAGE -->
              <div class="card-image">
                <div class="image-wrapper">
                  <a href="/th/plastics/industries/infrastructure">
                    <img src="/pages/products/industries/infras.jpg" alt="">
                  </a>
                </div>
                <div class="card-content">
                  <a href="/th/plastics/industries/infrastructure" class="card-title ff-open-sans f-21 fw-600">Infrastructure</a>
                  <!-- <span class="card-description">See our plastic resins from various brands</span> -->
                </div>
              </div>
              <!-- CARD IMAGE -->
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  
</template>
<script setup lang="ts">
useHead({
  title:'Industries - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding: 50px 0 0;
}
.page-title .title {
  margin: 40px 0 30px;
}

.section-row {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>